import React, { useRef, useEffect, useState, useContext } from "react";
import tinycolor from "tinycolor2";
import { useTranslation } from "react-i18next";
import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import ReactTooltip from "react-tooltip";
import { Header1, Header4, Header5, Header6 } from "./Header/Header1";
import { Header2 } from "./Header/Header2";
import { FrontApp1 } from "./Header/FrontApp1";
import { FrontApp2 } from "./Header/FrontApp2";
import { sectionPaddings, pageMargins } from "../../../TemplateConfig";
import "./Profile.css";
function Profile({
  resumeHandler,
  resumeUpdate,
  sectionId,
  resumeFields,
  showHideElements,
  setModalShow,
  styles,
  settings,
  SectionMargin,
  selectedBgColor,
  PageMargin,
  customStyle,
}) {
  const [sectionPading, setSectionPadding] = useState("unset");
  const [primaryColor, setPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");

  const { selectedFont, titleFont, bodyFont } = styles;

  useEffect(() => {
    if (styles && styles.bgColor && styles.bgColor.bgFill === "top") {
      setSecondaryColor(
        tinycolor(styles && styles.bgColor && styles.bgColor.bgColor).isLight()
          ? "#000"
          : "#fff"
      );
      setPrimaryColor(
        tinycolor(styles && styles.bgColor && styles.bgColor.bgColor).isLight()
          ? "#000"
          : "#fff"
      );
    } else {
      setSecondaryColor(styles.secondaryColor);
      setPrimaryColor(styles.primaryColor);
    }
  }, [styles]);

  const [t, i18n] = useTranslation("common");

  const profile = settings && settings.profile && settings.profile;

  const replace = (domNode) => {
    if (domNode.attribs && domNode.attribs.class === "resume-title-name") {
      return ProfileTitle(resumeHandler, resumeUpdate);
    } else if (
      domNode.attribs &&
      domNode.attribs.class === "resume-job-title"
    ) {
      return ProfileJobTitle(resumeHandler, resumeUpdate);
    } else if (
      domNode.attribs &&
      domNode.attribs.class === "profile-image-section"
    ) {
      return ProfileImageSection(
        handleChangeImage,
        handleRemoveImage,
        resumeUpdate
      );
    } else if (domNode.attribs && domNode.attribs.class === "profile-info") {
      return ProfileInfo(resumeHandler, resumeUpdate);
    }
  };

  var initialLetter =
    resumeFields &&
    resumeFields.data &&
    resumeFields.data[0] &&
    resumeFields.data[0].name &&
    resumeFields.data[0].name.charAt(0);

  //Methods
  const handleChangeImage = () => {
    setModalShow(true);
  };

  const handleRemoveImage = () => {
    showHideElements("photo", 0, sectionId);
  };

  let headerHtml;
  if (profile && profile != "") {
    if (profile.headerStyle == "Header1") {
      headerHtml = Header1;
    } else if (profile.headerStyle == "Header2") {
      headerHtml = Header2;
    } else if (profile.headerStyle == "Header3") {
      headerHtml = Header6;
    } else if (profile.headerStyle == "Header4") {
      headerHtml = Header4;
    } else if (profile.headerStyle == "Header5") {
      headerHtml = Header5;
    } else if (profile.headerStyle == "Header6") {
      headerHtml = Header6;
    } else if (profile.headerStyle == "FrontApp1") {
      headerHtml = FrontApp1;
    } else if (profile.headerStyle == "FrontApp2") {
      headerHtml = FrontApp2;
    } else {
      headerHtml = Header1;
    }
  }

  useEffect(() => {
    if (SectionMargin && SectionMargin) {
      const secMargin = parseInt(SectionMargin);
      setSectionPadding(sectionPaddings[secMargin - 1]);
    }
  }, [SectionMargin && SectionMargin]);

  const ProfileImageSection = (
    handleChangeImage,
    handleRemoveImage,
    resumeHandler,
    resumeUpdate
  ) => {
    return (
      resumeFields &&
      resumeFields.data &&
      resumeFields.data[0] &&
      resumeFields.data[0].showFields &&
      resumeFields.data[0].showFields.photo &&
      resumeFields.data[0].showFields.photo && (
        <>
          {/* <div className="profile-background-color"></div> */}
          <div
            className="profile-image-section pro_img_section "
            style={{
              width:
                profile && profile.profileSize == "medium" ? "120px" : "120px",
            }}
          >
            {resumeFields &&
            resumeFields.data &&
            resumeFields.data[0] &&
            resumeFields.data[0].photo != "" &&
            resumeFields &&
            resumeFields.data &&
            resumeFields.data[0] &&
            resumeFields.data[0].photo != null ? (
              <img
                src={resumeFields.data[0].photo}
                alt=""
                className="profileimg"
                style={{
                  borderRadius:
                    profile && profile.photoStyle == "round"
                      ? "50%"
                      : profile && profile.photoStyle == "square"
                      ? "0px"
                      : "10px",
                  width:
                    profile && profile.profileSize == "medium"
                      ? "120px"
                      : "120px",
                  height:
                    profile && profile.profileSize == "medium"
                      ? "120px"
                      : "120px",
                }}
              />
            ) : resumeFields.data[0].showFields.photo ? (
              <div
                className="initialimage"
                style={{
                  borderRadius:
                    profile && profile.photoStyle == "round" ? "50%" : "10px",
                  width:
                    profile && profile.profileSize == "medium"
                      ? "120px"
                      : "120px",
                  height:
                    profile && profile.profileSize == "medium"
                      ? "120px"
                      : "120px",
                  // backgroundColor: styles.primaryColor,
                }}
              >
                <div
                  style={{
                    width:
                      profile && profile.profileSize == "medium"
                        ? "120px"
                        : "120px",
                    height:
                      profile && profile.profileSize == "medium"
                        ? "120px"
                        : "120px",
                    lineHeight:
                      profile && profile.profileSize == "medium"
                        ? "120px"
                        : "120px",
                    textAlign: "center",
                    color: "white",
                  }}
                >
                  <img
                    className="w-100"
                    src="https://s3.us-east-1.amazonaws.com/qrapp-uat/assets/common/user.svg"
                  ></img>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="profile_actionbtns">
              <img
                data-tip="Edit"
                src="/images/edit-pencil.png"
                onClick={handleChangeImage}
                alt="resumeedit"
                className="mr-2"
                style={{ maxWidth: "25px", cursor: "pointer" }}
              />

              <img
                data-tip="Remove"
                src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
                onClick={handleRemoveImage}
                alt="resumeedit"
                className="mr-2 mt-3 "
                style={{ width: "25px", cursor: "pointer" }}
              />
            </div>
            <div
              className="overlaydiv"
              style={{
                borderRadius:
                  settings && settings.photoStyle == "round" ? "50%" : "10px",
              }}
            ></div>
          </div>
        </>
      )
    );
  };

  const ProfileInfo = (resumeHandler, resumeUpdate) => {
    return (
      <>
        {resumeFields &&
          resumeFields.data &&
          resumeFields.data[0] &&
          resumeFields.data[0] && (
            <>
              <div className="profile-info">
                {Object.keys(
                  resumeFields &&
                    resumeFields.data &&
                    resumeFields.data[0] &&
                    resumeFields.data[0]
                ).map((res, index, array) => {
                  if (res == "photo") {
                    return;
                  } else if (res == "jobTitle") {
                    return;
                  } else if (res == "name") {
                    return;
                  } else if (res == "showFields") {
                    return;
                  } else if (res == "profile_image") {
                    return;
                  }
                  let placeHolderText = "";
                  if (res.includes("customField")) {
                    placeHolderText = `Custom field-${res.split("_")[1]}`;
                  }

                  return (
                    <>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingBottom: "15px",
                        }}
                      >
                        {resumeFields &&
                          resumeFields.data &&
                          resumeFields.data[0] &&
                          resumeFields.data[0].showFields &&
                          resumeFields.data[0].showFields[res] && (
                            <>
                              {res == "email" ? (
                                <i
                                  className="fa fa-envelope-o fa-fw"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "phone" ? (
                                <i
                                  className="fa fa-phone  fa-fw"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "jobTitle" ? (
                                <i
                                  class="fa fa-black-tie"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "city" ? (
                                <i
                                  class="fa fa-map-marker"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "website" ? (
                                <i
                                  className="fa fa-globe  fa-fw"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "custom_google" ? (
                                <i
                                  class="fa fa-google"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "custom_linkedin" ? (
                                <i
                                  class="fa fa-linkedin"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "custom_facebook" ? (
                                <i
                                  class="fa fa-facebook-official"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "custom_yahoo" ? (
                                <i
                                  class="fa fa-yahoo"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "custom_github" ? (
                                <i
                                  class="fa fa-github"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "custom_instagram" ? (
                                <i
                                  class="fa fa-instagram"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "custom_twitter" ? (
                                <i
                                  class="fa fa-twitter"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "custom_skype" ? (
                                <i
                                  class="fa fa-skype"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "custom_signal" ? (
                                <i
                                  class="fa fa-signal"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : res == "custom_whatsapp" ? (
                                <i
                                  class="fa fa-whatsapp"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              ) : (
                                <i
                                  class="fa fa-check-circle"
                                  aria-hidden="true"
                                  style={{
                                    color: primaryColor,
                                    fontSize: selectedFont?.p2,
                                    fontStyle: "normal",
                                    lineHeight: selectedFont?.p2_lineHeight,
                                  }}
                                ></i>
                              )}

                              <ContentEditable
                                sectionId={sectionId}
                                name={res}
                                index={0}
                                tagType="span"
                                className={"profile-info-element"}
                                value={resumeFields.data[0][res]}
                                placeholder={
                                  res.includes("customField")
                                    ? placeHolderText
                                    : t(`profile.${[res]}`)
                                }
                                onChange={resumeHandler}
                                onBlur={resumeUpdate}
                                style={{
                                  color: primaryColor,
                                  fontFamily: bodyFont,
                                  fontSize: selectedFont?.p2,
                                  fontStyle: "normal",
                                  fontWeight: 500,
                                  lineHeight: selectedFont?.p2_lineHeight,
                                  paddingLeft: "10px",
                                  paddingRight: "12px",
                                }}
                              />
                            </>
                          )}
                      </div>
                    </>
                  );
                })}
              </div>
            </>
          )}
      </>
    );
  };

  const ProfileTitle = (resumeHandler, resumeUpdate) => {
    return (
      resumeFields &&
      resumeFields.data &&
      resumeFields.data[0] && (
        <ContentEditable
          sectionId={sectionId}
          name="name"
          tagType="div"
          className="resume-title-name"
          index={0}
          value={resumeFields.data[0].name}
          placeholder="Your Name"
          onChange={resumeHandler}
          onBlur={resumeUpdate}
          style={{
            fontFamily: titleFont,
            color: primaryColor,
            fontSize: selectedFont?.h1,
            fontWeight: 700,
            textTransform: "uppercase",
            lineHeight: selectedFont?.h1_lineHeight,
            fontStyle: "normal",
          }}
        />
      )
    );
  };

  const ProfileJobTitle = (resumeHandler, resumeUpdate) => {
    return (
      <>
        {resumeFields &&
          resumeFields.data &&
          resumeFields.data[0] &&
          resumeFields.data[0].showFields &&
          resumeFields.data[0].showFields.jobTitle &&
          resumeFields.data[0].showFields.jobTitle && (
            <ContentEditable
              sectionId={sectionId}
              name="jobTitle"
              index={0}
              tagType="div"
              className={"resume-job-name"}
              value={resumeFields.data[0].jobTitle}
              placeholder={t(`profile.jobTitle`)}
              onChange={resumeHandler}
              onBlur={resumeUpdate}
              style={{
                fontFamily: bodyFont,
                color: secondaryColor,
                fontSize: selectedFont?.h2,
                fontWeight: 500,
                lineHeight: selectedFont?.h2_lineHeight,
                fontStyle: "normal",
              }}
            />
          )}
      </>
    );
  };

  return (
    <>
      <ReactTooltip />

      {resumeFields && resumeFields.data && resumeFields.data[0] && (
        // <> {parse(headerHtml, { replace })}</>
        <div>
          <>
            {profile?.headerStyle == "Word1" ? (
              <>
                {" "}
                <div
                  className="d-flex "
                  style={{
                    padding: "10px 10px 0px 10px",
                  }}
                >
                  <div style={{ width: "67%" }}>
                    <div className="d-flex">
                      <div>
                        {ProfileImageSection(
                          handleChangeImage,
                          handleRemoveImage,
                          resumeHandler,
                          resumeUpdate
                        )}
                      </div>
                      <div className="profile_main_info ml-3">
                        {" "}
                        <div>{ProfileTitle(resumeHandler, resumeUpdate)}</div>
                        <div>
                          {ProfileJobTitle(resumeHandler, resumeUpdate)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "30%" }}>
                    <div>{ProfileInfo(resumeHandler, resumeUpdate)}</div>
                  </div>
                </div>
              </>
            ) : profile?.headerStyle == "Header1" ? (
              <>
                {" "}
                <div
                  className="d-grid grid-column"
                  style={{
                    padding: "0px 0px 0px 0px",
                    gap: "80px",
                    gridAutoColumns: ` ${
                      customStyle && customStyle.grid_width
                        ? customStyle.grid_width -
                          pageMargins[parseInt(PageMargin) - 1] -
                          40
                        : 372 - pageMargins[parseInt(PageMargin) - 1] - 40
                    }px 1fr`,
                  }}
                >
                  <div>
                    <div>{ProfileTitle(resumeHandler, resumeUpdate)}</div>
                    <div>{ProfileJobTitle(resumeHandler, resumeUpdate)}</div>
                    <div>{ProfileInfo(resumeHandler, resumeUpdate)}</div>
                  </div>
                  <div>
                    {ProfileImageSection(
                      handleChangeImage,
                      handleRemoveImage,
                      resumeHandler,
                      resumeUpdate
                    )}
                  </div>
                </div>
              </>
            ) : profile?.headerStyle == "Header2" ? (
              <>
                <div
                  className="d-flex "
                  style={{
                    padding: "0px 10px 0px 10px",
                    gap: "40px",
                  }}
                >
                  <div>
                    {ProfileImageSection(
                      handleChangeImage,
                      handleRemoveImage,
                      resumeHandler,
                      resumeUpdate
                    )}
                  </div>
                  <div className="d-flex w-100 justify-content-between">
                    <div style={{ alignSelf: "center" }}>
                      <div>{ProfileTitle(resumeHandler, resumeUpdate)}</div>
                      <div>{ProfileJobTitle(resumeHandler, resumeUpdate)}</div>
                    </div>
                    <div>{ProfileInfo(resumeHandler, resumeUpdate)}</div>
                  </div>
                </div>
              </>
            ) : profile?.headerStyle == "Header3" ? (
              <>
                <div
                  className="d-flex justify-content-center text-center"
                  style={{
                    padding: "0px 0px 0px 0px",
                  }}
                >
                  <div>
                    {ProfileImageSection(
                      handleChangeImage,
                      handleRemoveImage,
                      resumeHandler,
                      resumeUpdate
                    )}
                    <div>{ProfileTitle(resumeHandler, resumeUpdate)}</div>
                    <div>{ProfileJobTitle(resumeHandler, resumeUpdate)}</div>
                    <div>{ProfileInfo(resumeHandler, resumeUpdate)}</div>
                  </div>
                </div>
              </>
            ) : profile?.headerStyle == "Header4" ? (
              <>
                {" "}
                <div
                  className="d-flex "
                  style={{
                    padding: "0px 10px 0px 0px",
                  }}
                >
                  {" "}
                  <div style={{ width: "20%" }}>
                    {ProfileImageSection(
                      handleChangeImage,
                      handleRemoveImage,
                      resumeHandler,
                      resumeUpdate
                    )}
                  </div>
                  <div style={{ width: "78%" }} className="header_4_details">
                    <div>{ProfileTitle(resumeHandler, resumeUpdate)}</div>
                    <div>{ProfileJobTitle(resumeHandler, resumeUpdate)}</div>
                    <div>{ProfileInfo(resumeHandler, resumeUpdate)}</div>
                  </div>
                </div>
              </>
            ) : profile?.headerStyle == "Header5" ? (
              <>
                {" "}
                <div
                  className="d-grid grid-column"
                  style={{
                    padding: "0px 0px 0px 0px",
                    gap: "80px",
                    gridAutoColumns: ` ${
                      customStyle && customStyle.grid_width
                        ? customStyle.grid_width -
                          pageMargins[parseInt(PageMargin) - 1] -
                          40
                        : 372 - pageMargins[parseInt(PageMargin) - 1] - 40
                    }px 1fr`,
                  }}
                >
                  <div
                    className="d-flex"
                    style={{
                      gap: "40px",
                    }}
                  >
                    <div>
                      {ProfileImageSection(
                        handleChangeImage,
                        handleRemoveImage,
                        resumeHandler,
                        resumeUpdate
                      )}
                    </div>
                    <div style={{ alignSelf: "center" }}>
                      <div>{ProfileTitle(resumeHandler, resumeUpdate)}</div>
                      <div>{ProfileJobTitle(resumeHandler, resumeUpdate)}</div>
                    </div>
                  </div>

                  <div className="">
                    <div>{ProfileInfo(resumeHandler, resumeUpdate)}</div>
                  </div>
                </div>
              </>
            ) : profile?.headerStyle == "Header6" ? (
              <>
                {" "}
                <div
                  className="d-grid grid-column"
                  style={{
                    // padding: "0px 10px 0px 10px",
                    gap: "80px",
                    gridAutoColumns: ` ${
                      customStyle && customStyle.grid_width
                        ? customStyle.grid_width -
                          pageMargins[parseInt(PageMargin) - 1] -
                          40
                        : 372 - pageMargins[parseInt(PageMargin) - 1] - 40
                    }px 1fr`,
                  }}
                >
                  <div
                    className="d-flex"
                    style={{
                      gap: "40px",
                    }}
                  >
                    <div>
                      {ProfileImageSection(
                        handleChangeImage,
                        handleRemoveImage,
                        resumeHandler,
                        resumeUpdate
                      )}
                    </div>
                  </div>

                  <div className="">
                    <div style={{ alignSelf: "center" }}>
                      <div>{ProfileTitle(resumeHandler, resumeUpdate)}</div>
                      <div>{ProfileJobTitle(resumeHandler, resumeUpdate)}</div>
                    </div>
                    <div>{ProfileInfo(resumeHandler, resumeUpdate)}</div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {" "}
                <div
                  className="d-flex "
                  style={{
                    padding: "0px 10px 0px 10px",
                  }}
                >
                  <div style={{ width: "67%" }}>
                    <div>{ProfileTitle(resumeHandler, resumeUpdate)}</div>
                    <div>{ProfileJobTitle(resumeHandler, resumeUpdate)}</div>
                    <div>{ProfileInfo(resumeHandler, resumeUpdate)}</div>
                  </div>
                  <div style={{ width: "30%" }}>
                    {ProfileImageSection(
                      handleChangeImage,
                      handleRemoveImage,
                      resumeHandler,
                      resumeUpdate
                    )}
                  </div>
                </div>
              </>
            )}
          </>
        </div>
      )}
    </>
  );
}

export default Profile;
